import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../icon-v2/icon.component";
import * as i3 from "ngx-skeleton-loader";
/**
 * @deprecated use chip v3 component instead
 */
const _c0 = ["*"];
const _c1 = (a0, a1) => ({
  "gea-font-heading-20": a0,
  "gea-font-heading-16": a1
});
const _c2 = (a0, a1) => ({
  "p-highlight": a0,
  "p-disabled": a1
});
const _c3 = () => ({
  height: "22px",
  width: "95px",
  "border-radius": "5px"
});
function ChipComponent_ng_container_0_div_2_geaui_icon_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("fileSize", ctx_r0.size === "small" ? 16 : 24)("file", ctx_r0.preIcon)("color", ctx_r0.getReadonlyColor());
  }
}
function ChipComponent_ng_container_0_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ChipComponent_ng_container_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, ChipComponent_ng_container_0_div_2_geaui_icon_v2_1_Template, 1, 3, "geaui-icon-v2", 7)(2, ChipComponent_ng_container_0_div_2_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const content_r2 = i0.ɵɵreference(2);
    i0.ɵɵclassMapInterpolate2("geaui-chip-readonly geaui-chip-", ctx_r0.size, " geaui-chip-type-", ctx_r0.severity, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c1, ctx_r0.size === "medium", ctx_r0.size === "small"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.preIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function ChipComponent_ng_container_0_div_3_geaui_icon_v2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("fileSize", ctx_r0.size === "small" ? 16 : 24)("file", ctx_r0.preIcon)("baseUrl", ctx_r0.preIconBaseUrl)("color", ctx_r0.getInteractiveColor());
  }
}
function ChipComponent_ng_container_0_div_3_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
}
function ChipComponent_ng_container_0_div_3_geaui_icon_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("fileSize", ctx_r0.size === "small" ? 16 : 24)("file", ctx_r0.postIcon)("baseUrl", ctx_r0.postIconBaseUrl)("color", ctx_r0.getInteractiveColor());
  }
}
function ChipComponent_ng_container_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function ChipComponent_ng_container_0_div_3_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.toggle($event));
    })("mousedown", function ChipComponent_ng_container_0_div_3_Template_div_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.pressed = true);
    })("mouseup", function ChipComponent_ng_container_0_div_3_Template_div_mouseup_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.pressed = false);
    });
    i0.ɵɵtemplate(1, ChipComponent_ng_container_0_div_3_geaui_icon_v2_1_Template, 1, 4, "geaui-icon-v2", 11)(2, ChipComponent_ng_container_0_div_3_span_2_Template, 1, 0, "span", 8)(3, ChipComponent_ng_container_0_div_3_geaui_icon_v2_3_Template, 1, 4, "geaui-icon-v2", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const content_r2 = i0.ɵɵreference(2);
    i0.ɵɵclassMapInterpolate1("geaui-chip-interactive geaui-chip-", ctx_r0.size, " p-element p-button p-togglebutton");
    i0.ɵɵclassProp("geaui-pressed", ctx_r0.pressed);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c2, ctx_r0._active, ctx_r0.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.preIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.postIcon);
  }
}
function ChipComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtemplate(2, ChipComponent_ng_container_0_div_2_Template, 3, 10, "div", 4)(3, ChipComponent_ng_container_0_div_3_Template, 4, 12, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.readOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.readOnly);
  }
}
function ChipComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ChipComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c3));
  }
}
export class ChipComponent {
  readOnly = true;
  preIcon = '';
  preIconBaseUrl;
  postIcon = '';
  postIconBaseUrl;
  size = 'medium';
  loading = false;
  disabled = false;
  set active(active) {
    this._active = active;
  }
  severity = 'default';
  toggled = new EventEmitter();
  _active = false;
  pressed = false;
  toggle(originalEvent) {
    this._active = !this._active;
    this.toggled.emit({
      checked: this._active,
      originalEvent
    });
  }
  getInteractiveColor() {
    if (this.disabled) return 'grey';
    return this._active ? 'white' : 'blue';
  }
  getReadonlyColor() {
    switch (this.severity) {
      case 'error':
        return 'tertiary-red';
      case 'warning':
        return 'orange';
      case 'success':
        return 'green';
      case 'information':
        return 'active-blue';
      case 'progress':
        return 'radiant-orange';
      case 'default':
        return 'black';
      default:
        return 'blue';
    }
  }
  static ɵfac = function ChipComponent_Factory(t) {
    return new (t || ChipComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ChipComponent,
    selectors: [["geaui-chip"]],
    inputs: {
      readOnly: "readOnly",
      preIcon: "preIcon",
      preIconBaseUrl: "preIconBaseUrl",
      postIcon: "postIcon",
      postIconBaseUrl: "postIconBaseUrl",
      size: "size",
      loading: "loading",
      disabled: "disabled",
      active: "active",
      severity: "severity"
    },
    outputs: {
      toggled: "toggled"
    },
    ngContentSelectors: _c0,
    decls: 5,
    vars: 2,
    consts: [["content", ""], ["skeleton", ""], [4, "ngIf", "ngIfElse"], [1, "geaui-chip-container"], [3, "class", "ngClass", 4, "ngIf"], [3, "class", "geaui-pressed", "ngClass", "click", "mousedown", "mouseup", 4, "ngIf"], [3, "ngClass"], [3, "fileSize", "file", "color", 4, "ngIf"], [4, "ngTemplateOutlet"], [3, "fileSize", "file", "color"], [3, "click", "mousedown", "mouseup", "ngClass"], [3, "fileSize", "file", "baseUrl", "color", 4, "ngIf"], [3, "fileSize", "file", "baseUrl", "color"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function ChipComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, ChipComponent_ng_container_0_Template, 4, 2, "ng-container", 2)(1, ChipComponent_ng_template_1_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, ChipComponent_ng_template_3_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r4 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r4);
      }
    },
    dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2.IconComponent, i3.NgxSkeletonLoaderComponent],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-chip',
      template: "<ng-container *ngIf=\"!loading; else skeleton\">\n  <div class=\"geaui-chip-container\">\n    <div\n      class=\"geaui-chip-readonly geaui-chip-{{ size }} geaui-chip-type-{{ severity }}\"\n      *ngIf=\"readOnly\"\n      [ngClass]=\"{ 'gea-font-heading-20': size === 'medium', 'gea-font-heading-16': size === 'small' }\">\n      <geaui-icon-v2\n        *ngIf=\"preIcon\"\n        [fileSize]=\"size === 'small' ? 16 : 24\"\n        [file]=\"preIcon\"\n        [color]=\"getReadonlyColor()\"></geaui-icon-v2>\n      <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n    </div>\n    <div\n      class=\"geaui-chip-interactive geaui-chip-{{ size }} p-element p-button p-togglebutton\"\n      *ngIf=\"!readOnly\"\n      [class.geaui-pressed]=\"pressed\"\n      [ngClass]=\"{ 'p-highlight': _active, 'p-disabled': disabled }\"\n      (click)=\"toggle($event)\"\n      (mousedown)=\"pressed = true\"\n      (mouseup)=\"pressed = false\">\n      <geaui-icon-v2\n        *ngIf=\"preIcon\"\n        [fileSize]=\"size === 'small' ? 16 : 24\"\n        [file]=\"preIcon\"\n        [baseUrl]=\"preIconBaseUrl\"\n        [color]=\"getInteractiveColor()\"></geaui-icon-v2>\n      <span *ngTemplateOutlet=\"content\"></span>\n      <geaui-icon-v2\n        *ngIf=\"postIcon\"\n        [fileSize]=\"size === 'small' ? 16 : 24\"\n        [file]=\"postIcon\"\n        [baseUrl]=\"postIconBaseUrl\"\n        [color]=\"getInteractiveColor()\"></geaui-icon-v2>\n    </div>\n  </div>\n</ng-container>\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n\n<ng-template #skeleton>\n  <ngx-skeleton-loader [theme]=\"{ height: '22px', width: '95px', 'border-radius': '5px' }\" count=\"1\" appearance=\"line\">\n  </ngx-skeleton-loader>\n</ng-template>\n"
    }]
  }], null, {
    readOnly: [{
      type: Input
    }],
    preIcon: [{
      type: Input
    }],
    preIconBaseUrl: [{
      type: Input
    }],
    postIcon: [{
      type: Input
    }],
    postIconBaseUrl: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    active: [{
      type: Input
    }],
    severity: [{
      type: Input
    }],
    toggled: [{
      type: Output
    }]
  });
})();
